import React, { useEffect, useState } from "react";
import Wrapper from "../Components/Wrapper";
import { useContext } from "react";
import { MemoryTimerContext } from "../Context/MemoryTimerContext";
import MemoryConclusion from "./MemoryConclusion";
import MemoryGameHeading from "./MemoryGameHeading";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";
import {MemoryLevelContext} from "../Context/MemoryLevelContext";
import BigBurst from "../Animation/StarBling";

const MemoryCompleted = () => {

    const {updateCountDown} = useContext(MemoryCountDownContext);
    const {time, handleTimer} = useContext(MemoryTimerContext);
    const {memoryCompleted, handleMemoryCompleted, setReadyToCheckCards, displayTimer} = useContext(MemoryLevelContext);

    const handleClick = () => {
        handleMemoryCompleted(true);
        handleTimer(false);
        updateCountDown(false);
        setReadyToCheckCards(false);
    };

    useEffect(() => {
        scrollTo(0,0);
    }, [])

    return (
        <>
            <Wrapper background={"rgba(0, 0, 0, 0.8)"}>  
                <MemoryGameHeading/>
                <BigBurst />
                <div className="completed-memory-container">
                    <h2>Du klarade spelet!</h2>
                    {displayTimer &&
                        <div className="completed-memory-container__time">
                            <span className="completed-memory-container__clock">{("0" + Math.floor((time / 60000) % 60)).slice(-2)}:</span>
                            <span className="completed-memory-container__clock">{("0" + Math.floor((time / 1000) % 60)).slice(-2)}:</span>
                            <span className="completed-memory-container__clock">{("0" + ((time / 10) % 100)).slice(-2)}</span>
                        </div>
                    }
                    <p className="completed-memory-container__text">Bra jobbat, klicka på knappen för att spela mer och se facit</p>
                </div>
                <div className="completed-memory-buttons">
                    <span className="button-container">
                        <button className="button" onClick={() => handleClick()}>
                            <span className="label button--label">Gå vidare</span>
                            <span className="button--icon-container">
                                <i className="arrow arrow--right arrow--button" aria-hidden="true"></i>
                            </span>
                        </button>
                    </span>
                </div>
            </Wrapper>

            { memoryCompleted &&
                <MemoryConclusion />
            }
            
        </>
    );
};

export default MemoryCompleted;